import { combineReducers } from 'redux';
import Reports from './reportsReducer';
import mediaUpload from './MediaUpload';

export const rootReducer = combineReducers({
    Reports,
    mediaUpload,
});